var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.679 12.461"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 99",
    d: "M19.618 11.4l-9.279-9.279L1.06 11.4",
    fill: "none"
  })));
}

export default __webpack_public_path__ + "056c9f699b39d0845225c962dec7c133.svg";
export { SvgChevron as ReactComponent };